export default theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '250px',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  rowWrapper: {
    display: 'flex',
    alignItems: 'baseline'
  },
});
